import { BASEEASchemas } from "../form/sharedSchemas/BASE/EA";
import { GHGEASchemas } from "../form/sharedSchemas/GHG/EA";

export const getEASchemaByStandard = (standardId) => {
  switch (standardId) {
    case 1:
      return BASEEASchemas;
    case 2:
      return GHGEASchemas;
    default:
      return BASEEASchemas;
  }
};
